// 本文件内容储存了所有路由的父子关系，便于判断高亮显示逻辑
const o = {
  '/admin/index': [],
  '/admin/carposition': [],
  '/admin/financialAnalysis': [],
  '/admin/dataCenter': [],
  '/matterReview/list': [
    '/matterReview/detail',
  ],
  '/order/contract': [
    '/order/contract/own/tobe',
    '/order/contract/own/ing',
    '/order/contract/own/arrive',
    '/order/contract/own/uncheck',
    '/order/contract/own/done',
    '/order/contract/hire',
    '/order/contractview',
    '/order/contractview',
    '/order/contractview2',
    '/order/contractview3',
    '/order/contractview4',
    '/order/contractview5',
    '/order/contractfee',
    '/order/contractdetail',
  ],
  '/order/nocontract': [
    '/order/nocontract/own/tobe',
    '/order/nocontract/own/ing',
    '/order/nocontract/own/arrive',
    '/order/nocontract/own/uncheck',
    '/order/nocontract/own/done',
    '/order/nocontract/hire',
    '/order/nocontractview',
    '/order/nocontractview2',
    '/order/nocontractview3',
    '/order/nocontractview4',
    '/order/nocontractview5',
    '/order/nocontractfee',
    '/order/nocontractadd',
    '/order/nocontractdetail',
  ],
  '/order/makeup': [
    '/order/makeupdetail',
  ],
  '/order/recycle': [
    '/order/recycleview',
  ],
  '/contract/list': [
    '/contract/list/tobe',
    '/contract/list/ing',
    '/contract/list/uncheck',
    '/contract/list/done',
    '/contract/statistics',
    '/contract/detail',
    '/contract/orderlist',
    '/contract/orderlist/own/tobe',
    '/contract/orderlist/own/ing',
    '/contract/orderlist/own/arrive',
    '/contract/orderlist/own/uncheck',
    '/contract/orderlist/own/done',
    '/contract/orderlist/hire',
    '/contract/orderlist/all',
    '/contract/orderdetail',
    '/contract/orderDetail',
    '/contract/orderDetail2',
    '/contract/orderFeeDetail',
  ],
  '/contract/makeup': [
    '/contract/makeupdetail',
    '/contract/makeupedit',
  ],
  '/customer/manage': [
    '/customer/detail',
    '/customer/edit',
    '/customer/view',
    '/customer/kai',
  ],
  '/customer/carrier': [
    '/customer/carrierdetail',
  ],
  '/customer/log': [],
  '/vehicle/manage': [
    '/vehicle/detail',
    '/vehicle/view',
    '/vehicle/insurance',
    '/vehicle/document',
    '/vehicle/viewTrip',
    '/vehicle/position',
  ],
  '/vehicle/group': [
    '/vehicle/groupList'
  ],
  // '/vehicle/groupList': [],
  '/vehicle/expatriate': [
    '/vehicle/expatriatedetail',
    '/vehicle/expatriateview',
  ],
  '/vehicle/hang': [
    '/vehicle/hangdetail',
    '/vehicle/hangview',
  ],
  '/vehicle/inspect': [
    '/vehicle/inspectdetail',
    '/vehicle/inspectview',
    '/vehicle/inspecttables',
  ],
  '/vehicle/breakRules': [],
  '/vehicle/documents': [
    '/vehicle/documents/list',
    '/vehicle/documents/insurancelist',
    '/vehicle/document2',
    '/vehicle/insurance2',
  ],
  '/fix/list': [
    '/fix/add',
    '/fix/detail',
    '/fix/examine',
  ],
  '/fix/config': [],
  '/staff/manager/table': [
    '/staff/manager/table/1',
    '/staff/manager/table/2',
    '/staff/manager/table/3',
    '/staff/managerDetail',
  ],
  '/staff/mainAccountant/table': [
    '/staff/mainAccountant/table/1',
    '/staff/mainAccountant/table/2',
    '/staff/mainAccountant/table/3',
    '/staff/mainAccountantDetail',
  ],
  '/staff/specialAccountant/table': [
    '/staff/specialAccountant/table/1',
    '/staff/specialAccountant/table/2',
    '/staff/specialAccountant/table/3',
    '/staff/specialAccountantDetail',
  ],
  '/staff/cashier/table': [
    '/staff/cashier/table/1',
    '/staff/cashier/table/2',
    '/staff/cashier/table/3',
    '/staff/cashierDetail',
  ],
  '/staff/captain/table': [
    '/staff/captain/table/1',
    '/staff/captain/table/2',
    '/staff/captain/table/3',
    '/staff/captainDetail',
  ],
  '/staff/viceCaptain/table': [
    '/staff/viceCaptain/table/1',
    '/staff/viceCaptain/table/2',
    '/staff/viceCaptain/table/3',
    '/staff/viceCaptainDetail',
  ],
  '/staff/maintenance/table': [
    '/staff/maintenance/table/1',
    '/staff/maintenance/table/2',
    '/staff/maintenance/table/3',
    '/staff/maintenanceDetail',
  ],
  '/staff/vehicleService/table': [
    '/staff/vehicleService/table/1',
    '/staff/vehicleService/table/2',
    '/staff/vehicleService/table/3',
    '/staff/vehicleServiceDetail',
  ],
  '/staff/driver': [
    '/staff/driverDetail',
  ],
  '/staff/escort': [
    '/staff/escortDetail',
  ],
  '/staff/tempDriver': [
    '/staff/tempDriverDetail',
  ],
  '/staff/tempEscort': [
    '/staff/tempEscortDetail',
  ],
  '/attendance/vehicleAttendance': [],
  '/attendance/attendanceSummary': [],
  '/attendance/driverAttendance': [],
  '/attendance/escortAttendance': [],
  '/finance/feightStatistics': [],
  '/finance/shipper': [
    '/finance/viewOrder',
    '/finance/contractFix',
    '/finance/paymentHistory'
  ],
  '/finance/initialPayment': [
    '/finance/initialPaymentRecord',
    '/finance/initialAllPaymentRecord',
  ],
  '/finance/carrier': [
    '/finance/carrierOrder',
    '/finance/carrierPaymentHistory'
  ],
  '/finance/receivableAccounts': [
    '/finance/statistics',
  ],
  '/finance/stabilizationFund': [
    '/finance/commissionRecord',
    '/finance/extractRecord',
  ],
  '/finance/fixedFee': [],
  '/finance/drivingFee': [],
  '/finance/oilFee': [
    '/finance/oilfeedetails',
  ],
  '/finance/fixedFeeList': [
    '/finance/fixedFeeDetailList'
  ],
  '/finance/baseSalary': [],
  '/finance/estimatedProfit': [
    '/finance/monthorder',
    '/finance/monthfixrecord',
  ],
  '/finance/expenseSummary': [
    '/finance/tabledetails',
  ],
  '/finance/captainSalary': [
    '/finance/monthorderfleet',
    '/finance/monthfixrecordfleet',
  ],
  '/finance/monthlyStatistical': [],
  '/finance/monthlyAnalysis': [],
  '/finance/financeFleetAbnormal': [
    '/finance/abnormalFee',
  ],
  '/finance/financeFleetSummary': [],
  '/system/personal': [],
  '/system/vehicleFreightIndex': [],
  '/system/loginLog': [],
  '/system/stationConfig': [],
  '/system/cargoConfig': [],
  '/system/warningConfig': [],
  '/system/insuranceConfig': [],
  '/system/documentConfig': [],
  '/system/reminderConfig': [],
  '/system/vehicleTypeConfig': [],
  '/system/others': [],
  '/oilStation/fuelSales': [
    '/oilStation/fuelSalesList'
  ],
  '/oilStation/stock': [],
  '/help/operation': [],
  '/help/log': [],
  '/help/improve': [],
}

export default o
